import React, { FunctionComponent, useState } from 'react';
import { ButtonOutlinePrimary, useSnackbar } from '../../../components-v2/shared';
import styles from '../email-editor.module.scss';
import { SmsTestModal } from './SmsTestModal';
import { handlePromise } from '../../../util/async';
import { observer } from 'mobx-react';
import useStore from '../../../store/useStore';
import { EditAppEmailReducerAction, ServerRequestStatus } from '../EmailEditor.helpers';

export const EmailEditorSendSmsTestButton: FunctionComponent<{
    dispatch: (action: EditAppEmailReducerAction) => void;
    testSmsStatus: ServerRequestStatus;
    disabled: boolean;
    smsAlternativeText?: string | null;
    companyPhone?: string;
}> = observer(({ dispatch, testSmsStatus, disabled, smsAlternativeText, companyPhone }) => {
    const { store } = useStore();
    const { router, Api } = store;
    const { companyId, appEmailId } = router.params;
    const { addSnackbar } = useSnackbar();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Only show button if SMS Alternative has content
    const hasSmsContent = smsAlternativeText && smsAlternativeText.trim().length > 0;

    const handleSendSmsTest = async (phoneNumber: string) => {
        console.log('handleSendSmsTest called with phone number:', phoneNumber);
        dispatch({ name: 'updateTestSmsStatus', payload: 'sending' });

        const [, error] = await handlePromise(
            Api.client.post(`mail-templates/company/${companyId}/template/${appEmailId}/testEmail`, {
                sms: true,
                phoneNumber: phoneNumber
            })
        );

        if (error) {
            dispatch({ name: 'updateTestSmsStatus', payload: 'error' });
            addSnackbar('Failed to send test SMS. Please try again.', { variant: 'error' });
            return;
        }

        dispatch({ name: 'updateTestSmsStatus', payload: 'sent' });
        addSnackbar(`Test SMS was sent to ${phoneNumber}.`, { variant: 'success' });
        setTimeout(() => dispatch({ name: 'updateTestSmsStatus', payload: 'waiting' }), 5000);
        setIsModalOpen(false);
    };

    const buttonText = {
        waiting: 'Send SMS Test',
        sending: 'Sending...',
        sent: 'Sent!',
        error: 'Try Again'
    };

    if (!hasSmsContent) {
        return null; // Don't render if no SMS content
    }

    return (
        <>
            <div className={styles['email-editor-edit-app-test']}>
                <ButtonOutlinePrimary
                    type="button"
                    className={styles['email-editor-edit-app-test-button']}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log('SMS Button clicked - should open modal, NOT call API');
                        setIsModalOpen(true);
                    }}
                    disabled={testSmsStatus === 'sending' || testSmsStatus === 'sent' || disabled}
                >
                    {buttonText[testSmsStatus]}
                </ButtonOutlinePrimary>
            </div>
            <SmsTestModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSendSms={handleSendSmsTest}
                defaultPhoneNumber={companyPhone || ''}
                isLoading={testSmsStatus === 'sending'}
            />
        </>
    );
});
